import { useState } from 'react';
import { PageHeader } from '@/components/Header/Page/PageHeader';
import { PageInfoHeading } from '@/components/Header/Page/PageInfoHeading';
import {
  useGetAllVehiculeCheckTypes,
  useUpdateManyVehiculeCheckTypes,
} from '@/hooks/vehicule-check-type.hooks';
import { useNavigate } from 'react-router-dom';
import { VehiculeCheckTypeTableView } from '../components/VehiculeCheckTypeTableView';
import { TVehiculeCheckTypeSchema } from '@/schemas/vehicule-check-type/vehicule-check-type.schema';
import { VehiculeCheckTypeTableHeaders } from '../components/VehiculeCheckTypeTableHeaders';
import { VehiculeCheckTypeTableData } from '../components/VehiculeCheckTypeTableData';
import { Trans, useTranslation } from 'react-i18next';
import ConfirmationModal from '@/components/Custom/Modal/ConfirmationModal';
import Modal from '@/components/Modal';
import { useDeactivateField } from '@/hooks/deactivate-field.hooks';
import { HeadingButton } from '@/components/Custom/Button/HeadingButton';
import { ImportIcon } from '@/components/SvgIcons/ImportIcon';
import { WarningMessage } from '@/components/Message/WarningMessage';

export const VehiculeCheckTypeListPage = () => {
  const { t } = useTranslation('inspectionType');
  const navigate = useNavigate();
  const [totalActive, setTotalActive] = useState<number>(0);

  /**
   * === Deactivate Data section ===
   */
  const {
    numberOfItemsToDeactivate,
    pendingDeactivate,
    handleDeactivate,
    onConfirmDeactivate,
  } = useDeactivateField<TVehiculeCheckTypeSchema>({
    t,
    useUpdateData: useUpdateManyVehiculeCheckTypes,
  });
  /**
   * === END OF Deactivate Data section ===
   */

  const onGetTotalActive = (total: number) => {
    setTotalActive(total);
  };

  return (
    <>
      <PageHeader
        title={t('common:inspectionTypes')}
        totalItems={totalActive}
        headingElement={
          <PageInfoHeading text={t('common:detailsRelatedToCurrentSection')} />
        }
        actionListElement={
          <>
            <HeadingButton
              text={t('common:importAList')}
              leftIcon={
                <ImportIcon className="-mt-[1.5px] w-[15.5px] h-[17px] [&>path]:fill-light-inverse dark-mode:[&>path]:fill-gray-600" />
              }
              onClick={() => navigate('#')}
            />
            <HeadingButton
              text={t('addInspectionType')}
              leftIcon={
                <i className="-mt-[1.5px] ki-outline ki-plus-circle !text-[19.4px] text-light-inverse dark-mode:text-gray-600" />
              }
              onClick={() => navigate('/vehicule-check-type/create')}
            />
          </>
        }
      />
      <div>
        <VehiculeCheckTypeTableView<TVehiculeCheckTypeSchema>
          t={t}
          useGetAllData={useGetAllVehiculeCheckTypes}
          onGetTotalActive={onGetTotalActive}
          tableHeaders={VehiculeCheckTypeTableHeaders}
          tableData={VehiculeCheckTypeTableData}
          pendingDeactivate={pendingDeactivate}
          onDeactivate={handleDeactivate}
        />
      </div>
      <Modal
        id="information-modal"
        title={t('common:information')}
        centerY
        showCancelBtn={false}
        showSecondBtn={true}
        secondBtnLabel="Ok"
        size="small"
      >
        <WarningMessage message={t('common:unableToDeactivateLinkedItem')} />
      </Modal>
      <ConfirmationModal
        id="deactivation-confirm-modal"
        title={t('common:confirmation')}
        description={
          numberOfItemsToDeactivate > 1 ? (
            <Trans i18nKey="common:confirmDeactivateItems" />
          ) : (
            t('common:confirmDeactivateItem')
          )
        }
        onConfirmLabel={t('common:deactivate')}
        onConfirm={onConfirmDeactivate}
      />
    </>
  );
};
